import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';

const OtherOptionInput = props => {
  const { checked, onChange, value, inputProps } = props;

  if (checked) {
    return <Input onChange={onChange} value={value} {...inputProps} />;
  }
  return null;
};

OtherOptionInput.propTypes = {
  checked: PropTypes.bool,
  inputProps: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default OtherOptionInput;
